module.exports = __webpack_public_path__ + "img/gris-1.9f16ee10.png";